export default "__VITE_ASSET__BrCmNhF7__"